import { useContext } from 'react';
import { StepIndicatorContext } from '../context/StepIndicatorContext';
export const useStepIndicator = () => {
  const context = useContext(StepIndicatorContext);
  if (!context) {
    throw new Error('useStepIndicator must be used within a StepIndicatorProvider or LocalStepIndicatorProvider');
  }
  return context;
};
//# sourceMappingURL=useStepIndicator.js.map